export default __webpack_public_path__ + "static/media/ic-yahoo.c9788299.svg";